// extracted by mini-css-extract-plugin
export default {"container":"PromoItem_container--ZcJ","similarPromo":"PromoItem_similarPromo--hoO","promoTitle":"PromoItem_promoTitle--4g5"};